import styles from './ccf-interaction-search-threads-tab.module.scss';
import {
  CcfAlignRightIcon,
  CcfBox,
  CcfDeboucedInput,
  CcfInteractionAcdIcon,
  CcfInteractionEmailIcon,
  CcfInteractionSearchChatIcon,
  CcfInteractionSearchColumnIcon,
  CcfInteractionSearchOutboundIcon,
  CcfOverflowIcon,
  CcfSupervisorFilterIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { interactionSearchData } from '../../ccf-interaction-search-cases-tab/ccf-interaction-search-cases-tab/ccf-interactionSearch-staticData';
import { fomatToDateString, fomatToTimeString } from '@nice-ccf/core-sdk';
import { Button, useTheme, useMediaQuery, Theme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
/* eslint-disable-next-line */
export interface CcfInteractionSearchThreadsTabProps {}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
});

/**
 * Function to handle drawer open close
 * @example renderIconForType()
 */
const renderIconForType = (param: string) => {
  switch (param) {
    case 'email':
      return <CcfInteractionEmailIcon />;
    case 'inbound':
      return <CcfInteractionAcdIcon />;
    case 'outbound':
      return <CcfInteractionSearchOutboundIcon />;
    case 'chat':
      return <CcfInteractionSearchChatIcon />;
    default:
      return '';
  }
};

export const columns = [
  {
    field: 'createdAt',
    headerName: 'created date'.toUpperCase(),
    flex: 1,
    maxWidth: 270,
  },
  {
    field: 'channel',
    headerName: 'channel'.toUpperCase(),
    headerClassName: 'gridHeaderText',
    renderCell: (params: any) => {
      const iconType =
        params.value === 'voice' && params.row.voiceDirection === 'inbound'
          ? 'inbound'
          : params.value === 'voice' && params.row.voiceDirection === 'outbound'
          ? 'outbound'
          : params.value;

      return renderIconForType(iconType);
    },
    hide: false,
    flex: 1,
    maxWidth: 200,
  },
  {
    field: 'customerName',
    headerName: 'Customer Name'.toUpperCase(),
    flex: 1,
    maxWidth: 230,
  },
  {
    field: 'interactions',
    headerName: 'interactions'.toUpperCase(),
    flex: 1,
    maxWidth: 250,
    headerClassName: 'gridHeaderText',
    renderCell: (params: any) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowForwardIcon
          fontSize="small"
          style={{ marginRight: '5px', fill: '#3498db' }}
        />
        <CcfTypography style={{ color: '#3498db' }}> Open </CcfTypography>
      </div>
    ),
  },
  {
    field: 'messages',
    headerName: 'messages'.toUpperCase(),
    flex: 1,
    maxWidth: 290,
    headerClassName: 'gridHeaderText',
    renderCell: (params: any) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowForwardIcon
          fontSize="small"
          style={{ marginRight: '5px', fill: '#3498db' }}
        />
        <CcfTypography style={{ color: '#3498db' }}>Open</CcfTypography>
      </div>
    ),
  },
];
/**
 * CcfInteractionSearchThreadsTab - used to display threads in interaction search tabs
 * @param props -? - CcfInteractionSearchThreadsTabProps
 * @example - <CcfInteractionSearchThreadsTab />
 */
export function CcfInteractionSearchThreadsTab(
  props: CcfInteractionSearchThreadsTabProps
) {
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const theme: Theme = useTheme();

  const isSmView = useMediaQuery(theme.breakpoints.down('xl'), { noSsr: true });
  const mobileViewColumns = [
    {
      field: 'createdAt',
      headerName: 'created date'.toUpperCase(),
      flex: 1,
      maxWidth: 270,
    },
    {
      field: 'channel',
      headerName: 'channel'.toUpperCase(),
      headerClassName: 'gridHeaderText',
      renderCell: (params: any) => {
        const iconType =
          params.value === 'voice' && params.row.voiceDirection === 'inbound'
            ? 'inbound'
            : params.value === 'voice' &&
              params.row.voiceDirection === 'outbound'
            ? 'outbound'
            : params.value;

        return renderIconForType(iconType);
      },
      hide: false,
      flex: 1,
      maxWidth: 200,
    },
    {
      field: 'customerName',
      headerName: 'Customer Name'.toUpperCase(),
      flex: 1,
      maxWidth: 230,
    },
  ];

  useEffect(() => {
    const rd = interactionSearchData.data.map((x, i) => {
      const icon = x.channelId.split('_')[0];
      return {
        id: i,
        channel: icon,
        createdAt:
          `${new Date(x.createdAt)}` !== 'Invalid Date'
            ? fomatToDateString(new Date(x.createdAt)) +
              ' ' +
              fomatToTimeString(new Date(x.createdAt))
            : '',
        customerName: `${x.authorEndUserIdentity.firstName} ${x.authorEndUserIdentity.lastName}`,
        voiceDirection: x.direction,
      };
    });
    setRowData(rd);
  }, []);

  return (
    <CcfBox
      id={`agent_interactionSearch_threads_tab_container`}
      style={{ height: '100%', width: '100%' }}
    >
      {' '}
      <CcfBox className={styles.tableBlock}>
        <CcfBox className={styles.tableHeader}>
          <CcfBox
            id={`agent_interactionSearch_threads_tab_filtersContainer`}
            className={styles.filterIconBlock}
            sx={isSmView ? { width: '30%' } : { width: '8%' }}
          >
            <Button
              sx={{
                gap: '7px',
                padding: 0,
                width: '24px',
                height: '38px',
                minWidth: 'auto',
                '&.MuiButtonBase-root:hover': { bgcolor: 'transparent' },
              }}
              id="agent_interactionSearch_threads_filters_button"
            >
              <CcfSupervisorFilterIcon style={{ fontSize: 14 }} />
              <CcfTypography className={styles.filtersHeader}>
                Filters
              </CcfTypography>
            </Button>
          </CcfBox>
          <CcfBox
            id={`agent_interactionSearch_threads_tab_customColumns`}
            className={
              !isSmView ? styles.columnIconBlock : styles.columnIconHideBlock
            }
          >
            <div style={{ height: '18px' }}>
              {isSmView ? (
                <CcfOverflowIcon />
              ) : (
                <CcfInteractionSearchColumnIcon />
              )}
            </div>
            {!isSmView && (
              <CcfTypography className={styles.filtersHeader}>
                Columns
              </CcfTypography>
            )}
          </CcfBox>
          <CcfBox flexDirection="column" height="100%">
            {/* <CcfInteractionSearchCustomizableMenu /> */}
          </CcfBox>
        </CcfBox>
        <CcfBox style={{ height: '495px', overflowY: 'scroll' }}>
          <CcfBox
            style={{
              height: 'inherit',
              backgroundColor: '#FFFF',
              overflowY: 'hidden',
              borderTop: '1px solid #E1E1E1',
            }}
            id={`agent_interactionSearch_threads_tab_dataGridContainer`}
          >
            {' '}
            <DataGrid
              classes={{ root: classes.root }}
              rows={rowData}
              columns={isSmView ? mobileViewColumns : columns}
              rowHeight={40}
              // getRowId={(row) => row?.id}
              pageSize={10}
              headerHeight={40}
              // onSelectionModelChange={handleSelectionChange}
              // autoHeight
              pagination
              rowsPerPageOptions={[5, 10, 25]}
              getRowClassName={(params: any) => `styledrows`}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#3F5C69',
                  fontWeight: '600',
                  fontSize: '12px',
                  fontFamily: 'Open Sans',
                },
              }}
            />
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}

export default CcfInteractionSearchThreadsTab;
